// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dd-a";
export var fulfillmentFormRail = "_dd-9";
export var headerTitleRow = "_dd-c";
export var orderDetailsWrapper = "_dd-7";
export var orderLinkTrigger = "_dd-2";
export var paymentInformationGrid = "_dd-h";
export var paymentSummaryColumn = "_dd-i";
export var shipmentContainer = "_dd-b";
export var shipmentDetailsMainPane = "_dd-8";
export var shipmentNavigationCard = "_dd-5";
export var shipmentNavigationRail = "_dd-3";
export var shipmentNavigationRailHeader = "_dd-4";
export var shipmentSummaryFact = "_dd-e";
export var shipmentSummaryGrid = "_dd-d";
export var shipmentSummaryMetadataRow = "_dd-f";
export var shipmentSummaryTags = "_dd-g";
export var shipmentWorkspace = "_dd-0";
export var shipmentWorkspaceContent = "_dd-6";
export var shipmentWorkspaceHeader = "_dd-1";